import { useEffect } from 'react';
import { useParams } from 'react-router';

import { redirectTo } from '#/lib/redirect';
import { UnreachableCaseError } from '#/lib/utils';
import { setBankrollCode } from '#/reduxState/currentUserData/userBankroll';
import { staticDispatch, useSelector } from '#/reduxState/store';

export default function BankrollAccessRedirectPage({
  type,
}: {
  type: 'welcomePoints' | 'bankroll';
}) {
  const { code } = useParams<{ code?: string }>();

  const walletAddress = useSelector(state => state.wallet.walletAddress);
  useEffect(() => {
    if (code) {
      switch (type) {
        case 'bankroll':
          staticDispatch(setBankrollCode(code, 'bankroll'));
          break;
        case 'welcomePoints':
          staticDispatch(setBankrollCode(code, 'welcomePoints'));
          break;
        default:
          throw new UnreachableCaseError(type);
      }
    }
    setTimeout(() => {
      redirectTo('/');
    });
  }, [code, type, walletAddress]);

  return null;
}
